"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _checkmarkCircle = require("../../assets/icons/checkmark-circle.svg");
var _infoCircleLarge = require("../../assets/icons/info-circle-large.svg");
var _infoOctogonLarge = require("../../assets/icons/info-octogon-large.svg");
var _warning = require("../../assets/icons/warning.svg");
var _close = require("../../assets/icons/close.svg");
var _alertModule = _interopRequireDefault(require("./alert.module.scss"));
var getIconElement = function getIconElement(type) {
  switch (type) {
    case 'info':
      return _infoCircleLarge.ReactComponent;
    case 'error':
      return _infoOctogonLarge.ReactComponent;
    case 'warning':
      return _warning.ReactComponent;
    case 'success':
      return _checkmarkCircle.ReactComponent;
    default:
      return _infoCircleLarge.ReactComponent;
  }
};
var Alert = function Alert(_ref) {
  var _classnames;
  var children = _ref.children,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    _ref$showClose = _ref.showClose,
    showClose = _ref$showClose === void 0 ? false : _ref$showClose,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    description = _ref.description,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var IconElement = getIconElement(type);
  var close = (0, _react.useCallback)(function () {
    return setShow(false);
  }, []);
  if (!show) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "alert-container",
    className: (0, _classnames2.default)(_alertModule.default['alert-container'], _alertModule.default["alert-".concat(type)], className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, _alertModule.default['alert-container--inline'], inline), (0, _defineProperty2.default)(_classnames, _alertModule.default['alert-container--small'], small), _classnames))
  }, showClose && /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    "data-testid": "close-icon",
    onClick: close,
    className: _alertModule.default['icon-close']
  }), !inline && /*#__PURE__*/_react.default.createElement(IconElement, {
    className: _alertModule.default["icon-".concat(type)],
    "data-testid": "alert-icon"
  }), title && /*#__PURE__*/_react.default.createElement("h4", {
    className: _alertModule.default['title']
  }, title), description && /*#__PURE__*/_react.default.createElement("p", {
    className: _alertModule.default['description']
  }, description), children);
};
exports.Alert = Alert;